import { ReactNode, RefObject, useRef, useEffect, useCallback } from 'react'
import { useOnClickOutside } from '../use-on-click-outside'
import { useToggle } from '../use-toggle'
import { Button } from './button'

export function InPlace<T extends HTMLElement = HTMLElement>({
	children,
	onToggle,
}: {
	children: [
		ReactNode,
		ReactNode | ((context: { ref: RefObject<T>; onClickOutside: VoidFunction }) => ReactNode),
	]
	onToggle?: (ref: RefObject<T>) => void
}) {
	const [isToggled, toggle] = useToggle(false)
	const ref = useRef<T>(null)
	const onClickOutside = useCallback(() => {
		if (isToggled) {
			toggle(false)
			if (ref.current) {
				onToggle?.(ref)
			}
		}
	}, [isToggled, toggle, onToggle])

	useOnClickOutside(ref, onClickOutside, isToggled)

	useEffect(() => {
		if (isToggled && ref.current) {
			ref.current.focus?.()
			ref.current.addEventListener('blur', onClickOutside)
			return () => {
				ref.current?.removeEventListener('blur', onClickOutside)
			}
		}
	}, [isToggled, onClickOutside])

	if (isToggled) {
		if (typeof children[1] === 'function') {
			return children[1]({ ref, onClickOutside })
		}
		return <div ref={ref as unknown as RefObject<HTMLDivElement>}>{children[1]}</div>
	}

	return (
		<div className="flex items-center justify-between gap-4">
			{children[0]}
			<Button variant="TEXT" size="SMALL" onFocus={toggle} className="rounded-md">
				Upravit
			</Button>
		</div>
	)
}
